import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const Main = (props) => {
  const location = useLocation();
  const currentPathName = location?.pathname;
  return (
    <>
      <Navbar />
      {props.children}
      {currentPathName !== "/account" && <Footer />}
    </>
  );
};

export default Main;
